// extracted by mini-css-extract-plugin
export default {"load_line":"place-holder_load_line__XRRRi","activity":"place-holder_activity__sp21g","loading":"place-holder_loading__SjT1Z"};